import * as i0 from "@angular/core";
var SupportedBrowsersService = /** @class */ (function () {
    function SupportedBrowsersService() {
        this.isUnsupportedBrowserAlertClosed = false;
    }
    SupportedBrowsersService.prototype.openChromeDownloadPage = function () {
        window.open('https://www.google.com/chrome/', '_blank');
    };
    SupportedBrowsersService.prototype.shouldDisplayModal = function () {
        var isSupportedBrowser = this.isSupportedBrowser();
        var modalHaveBeenShown = this.getModalHaveBeenShown();
        return !isSupportedBrowser && !modalHaveBeenShown;
    };
    SupportedBrowsersService.prototype.shouldDisplayAlert = function () {
        return !this.isSupportedBrowser() && !this.isUnsupportedBrowserAlertClosed;
    };
    SupportedBrowsersService.prototype.isSupportedBrowser = function () {
        var chromeVersion = this.getChromeVersion();
        return chromeVersion >= 69;
    };
    SupportedBrowsersService.prototype.getModalHaveBeenShown = function () {
        return !!localStorage.getItem('unsupported-browser-popup');
    };
    SupportedBrowsersService.prototype.setModalHaveBeenShown = function () {
        localStorage.setItem('unsupported-browser-popup', 'true');
    };
    SupportedBrowsersService.prototype.getChromeVersion = function () {
        var chromeVersion = navigator.userAgent.match(/Chrom(e|ium)\/([0-9]+)\./);
        return chromeVersion ? parseInt(chromeVersion[2], 10) : 0;
    };
    SupportedBrowsersService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SupportedBrowsersService_Factory() { return new SupportedBrowsersService(); }, token: SupportedBrowsersService, providedIn: "root" });
    return SupportedBrowsersService;
}());
export { SupportedBrowsersService };
